<template>
  <div id="classifyContent" :class="{ 'allFix': allFix }">
    <van-search disabled placeholder="请输入您想找的宝贝名称" shape="round" @click="searchClick()"/>
    <div class="content">
      <van-sidebar v-model="activeKey" class="contentLeft" @change="classifyChange">
        <van-sidebar-item :title="item.classifyName" v-for="item in classifyList" :key="item.classifyId"/>
      </van-sidebar>
      <div class="contentRight">
        <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            @load="onLoad"
        >
          <van-card
            v-for="(val,key) in goodsList" :key="key"
            :thumb="getFirstImg(val.productImage)"
            @click="$router.push(`/goodsDetail/${val.productId}`)"
            :origin-price="val.productPrice">
                <template #price>
                    <div><span class="van-card__price-currency">¥</span><span class="van-card__price-integer">{{val.productPreferentialPrice}}</span></div>
                </template>
              <template #title>
                  <p class="cardTitle">{{val.productName}}</p>
              </template>
              <template #desc>
                  <p class="cardDesc">已售{{val.productSalesNumber}}&nbsp;&nbsp;剩余{{val.productNum}}</p>
              </template>
              <template #num>
                  <img class="cardNum" src="~img/home/add.png" alt="" @click.stop="addFn(val.productId)">
              </template>
          </van-card>
        </van-list>
        <common-empty text="暂未找到商品" v-if="!goodsList.length"></common-empty>
        <common-search ref="commonSearch" :businessProperty="businessProperty"></common-search>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CommonSearch from '@/components/CommonSearch';
import baseUrl from '@/config/baseUrl';
import Cart from '@/config/shopCart';
export default {
    name: 'ClassifyContent',
    mixins: [Cart],
    props: {
        allFix: Boolean,
        businessProperty: Number
    },
    components: {
        CommonSearch
    },
    data() {
        return {
            activeKey: 0,
            loading: false,
            finished: false,
            searchData: {
                page: 1,
                rows: 10,
                classifyHigherId: ''
            },
            baseUrl
        };
    },
    computed: {
        ...mapState('classify', {
            classifyList: 'classifyList'
        }),
        ...mapState('goods', {
            goodsList: 'goodsList'
        })
    },
    methods: {
        ...mapActions('classify', {
            getClassifyList: 'getClassifyListAction'
        }),
        ...mapActions('goods', {
            getGoodsList: 'getGoodsListAction'
        }),
        ...mapActions('bfMerchantsShop', {
            shopCartModify: 'shopCartModifyAction'
        }),
        ...mapActions('shoppingCart', {
            getCartNum: 'getCartNumAction'
        }),
        getFirstImg(s) {
            let arr = s.split(',');
            return arr.length ? baseUrl.imgUrl + arr[0] : '';
        },
        onLoad() {
            this.loading = true;
            if(this.businessProperty===3){
                this.searchData.productClassifyId = this.searchData.classifyHigherId;
                delete this.searchData.classifyHigherId;
            }
            this.getGoodsList(this.searchData).then((res) => {
                this.searchData.page++;
                this.loading = false;
                if(res.length<10) {
                    this.finished = true;
                }
            });
        },
        classifyChange(index) {
            let row = this.classifyList[index];
            if(row) {
                this.searchData.page = 1;
                this.searchData.classifyHigherId = row.classifyId;
                this.onLoad();
            }
        },
        addFn(data){
            this.shopCartModify({ productId: data, productNum: 1
            }).then((res) => {
                this.$toast.success('添加成功');
                //拉取购物车总数量
                this.getCartNum();
                if(this.businessProperty){
                    this.getCartList({ businessProperty: this.businessProperty });
                }
            }).catch((res) => {
                this.$toast(res.error);
            });
        },
        searchClick(){
            this.$refs.commonSearch.visible = true;
        }
    },
    created() {
        this.searchData.businessProperty = this.businessProperty;
        let params =this.businessProperty===2?{}:{businessNumber:this.$store.state.businessNumber.businessNumber};
        this.getClassifyList({businessProperty:this.businessProperty,...params}).then((res) => {
            if(res.length) {
                if(this.$route.query.classifyId){
                    for(let i=0;i<this.classifyList.length;i++){
                        if(this.classifyList[i].classifyId===Number(this.$route.query.classifyId)){
                            this.activeKey = i;
                        }
                    }
                    this.searchData.classifyHigherId = this.$route.query.classifyId;
                }else{
                    this.searchData.classifyHigherId = res[0].classifyId;
                }
                this.onLoad();
            }
        });
    }
};
</script>
<style lang="scss">
#classifyContent {
    position: absolute;
    left: 0;
    right: 0;
    top: 42px;
    bottom: 50px;
    display: flex;
    flex-direction: column;
  .content {
    display: flex;
    margin-top: 1px;
    overflow: hidden;
    height: 100%;
    .contentLeft {
        overflow-y: auto;
      .van-sidebar-item {
        background: bottom;
        font-weight: 500;
      }
      .van-sidebar-item--select,
      .van-sidebar-item--select:active {
        background-color: #fff;
        color: #eb5435;
        border-color: #eb5435;
        font-weight: bold;
      }
    }
    .contentRight {
      background: #fff;
      flex: 1;
      overflow-y: auto;
      .van-card:last-child{
        border-bottom:none;
      }
      .van-card{
        background: bottom;
        text-align: left;
        border-bottom: 1px solid #E5E5E5;
        padding: 15px 0;
        margin: 0 10px;
        .cardTitle{
            font-size:15px;
            font-family:PingFang SC;
            font-weight:bold;
            color:rgba(51,51,51,1);
            line-height:20px;
            white-space: nowrap;
            text-overflow:ellipsis;
            overflow:hidden;
            margin-bottom: 10px;
        }
        .cardDesc{
            font-size:12px;
            font-family:PingFang SC;
            font-weight:500;
            color:rgba(163,163,163,1);
            line-height:15px;
        }
        .van-card__price{
            color: #E85B4D;
        }
        .cardNum{
            width:25px;
            height:25px;
            float: right;
        }
        .van-card__thumb img{
            border-radius:0px;
        }
      }
    }
  }
}
.allFix {
  bottom: 0!important;
}
</style>
